import {KTSVG} from '../../../../helpers'
import {Item, WpTypes} from '../../../../../app/pages/wp/types'
import {FC} from 'react'
import {Functions} from '../../../../../app/modules/all-pages'


type Props = {
    data: Item[],
}

const TablesWidget25: FC<Props> = ({data}) => {

    const typeColors: Record<WpTypes, string> = {
        wp: 'primary',
        theme: 'orange',
        plugin: 'info',
    };

    return (
        <>
            <div className="table-responsive">
                <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
                    <thead>
                    <tr className="fw-bolder text-muted bg-light">
                        <th className="ps-5 fw-bolder text-muted bg-light w-lg-125px">
                            <span className="text-gray-500">Date</span>
                        </th>
                        <th className="ps-5 fw-bolder text-muted bg-light w-lg-125px">
                            <span className="text-gray-500">Nom</span>
                        </th>
                        <th className="ps-5 fw-bolder text-muted bg-light w-lg-125px">
                            <span className="text-gray-500">Type</span>
                        </th>
                        <th className="ps-5 fw-bolder text-muted bg-light w-lg-125px">
                            <span className="text-gray-500">Versions</span>
                        </th>
                    </tr>
                    </thead>

                    <tbody>
                    {
                        data.map((item, index) => (
                            <tr key={index}>
                                <td className="px-5">
                                    <span
                                        className="text-dark fw-bolder fs-7 pe-4 d-flex align-items-center pl-5">{Functions.FormatDateToCA(item.created_at, true)}</span>
                                </td>
                                <td>
                                    <div className="d-flex flex-column w-100 me-2">
                                        <span className="text-muted me-2 fs-7 fw-bold">{item.name}</span>
                                    </div>
                                </td>
                                <td>
                                    <span
                                        className={`badge badge-light-${typeColors[item.type]} fw-bold fs-8 text-start text-capitalize`}>{item.type}</span>

                                </td>
                                <td className="text-center">
                                    <div className="">
                                        <span
                                            className="badge badge-light-danger fw-bold fs-8 text-start">{item.oldVersion}</span>
                                        <KTSVG path={`/media/icons/duotune/arrows/arr064.svg`}
                                               className="svg-icon-4 svg-icon-primary mx-0" />
                                        <span
                                            className="badge badge-light-success fw-bold fs-8 text-end">{item.newVersion}</span>
                                    </div>
                                </td>
                            </tr>
                        ))
                    }
                    </tbody>

                </table>
            </div>
        </>
    )
}

export {TablesWidget25}